export default __webpack_public_path__ + "static/media/Close.9cb8d6ba.svg";